<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentcolor">
    <path d="M20 2H4V16L12 22L20 16V2Z" />
  </svg>
</template>

<script>
export default {};
</script>
